import { useEffect, useRef } from "react";
import $ from "jquery";
import { LenguageTabla } from "../../../Comunes/LenguajeTabla/LenguajeTabla";

function CorreosSolicitud({ listaCorreos }) {
  const tableRef = useRef();

  useEffect(() => {
    $(tableRef.current).DataTable({
      language: LenguageTabla,
      processing: true,
      destroy: true,
      data: listaCorreos,
      columns: [
        {
          title: "Nombre del Auditor",
          data: "nombrePersona",
        },
        {
          title: "Correo Electrónico",
          data: "correoElectronico",
        },
      ],
    });
  }, [listaCorreos]);

  return (
    <div className="card shadow mb-4">
      <div className="card-header">
        <h6 className="m-0 font-weight-bold text-primary">
          Correos de la Solicitud
        </h6>
      </div>
      <div className="card-body">
        <table
          className="table table-striped table-hover w-auto display"
          ref={tableRef}
        />
      </div>
    </div>
  );
}

export default CorreosSolicitud;
